var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificationicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 7.40039,
    r: 7,
    fill: "#F9F9F9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.02888 11.4547V5.69659H6.45802V11.4547H8.02888ZM7.23557 5.22201C7.50876 5.22201 7.74343 5.13094 7.93956 4.94881C8.1322 4.76318 8.22852 4.54253 8.22852 4.28685C8.22852 4.02767 8.1322 3.80701 7.93956 3.62488C7.74343 3.43925 7.50876 3.34644 7.23557 3.34644C6.96238 3.34644 6.72946 3.43925 6.53683 3.62488C6.34069 3.80701 6.24262 4.02767 6.24262 4.28685C6.24262 4.54253 6.34069 4.76318 6.53683 4.94881C6.72946 5.13094 6.96238 5.22201 7.23557 5.22201Z",
    fill: "#F1B034"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationicon);
export default __webpack_public_path__ + "static/media/notification icon.17aac4478897979f0e4b873b3822aaae.svg";
export { ForwardRef as ReactComponent };